// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parent-container-dummy {
  position: absolute;
  z-index: 4;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.show_screen {
  opacity: 1;
}
.noshow_screen {
  pointer-events: none;
  opacity: 0;
}

.ins-division {
  transition: all 2s;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 300px;
  width: 639px;
  background-color: #fff;
  position: relative;
}

@supports (backdrop-filter: none) {
  .ins-division {
    /* background-color: rgba(255, 255, 255, 0.55);
    background: radial-gradient(
      100% 100% at 0% 0%,
      rgba(255, 255, 255, 0.4) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    -webkit-backdrop-filter: blur(16px) saturate(180%);
    backdrop-filter: blur(16px) saturate(180%);
    box-shadow: -5px -5px 250px 0px #ffffff05 inset; */
    
   background: radial-gradient(
      100% 100% at 0% 0%,
      rgba(169, 162, 162, 0.2) 70%,
      rgba(151, 147, 147, 0.2) 100%
    );
    backdrop-filter: blur(10px) saturate(100%);
  }
}

.ins-sub-container {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  margin-top: 20px;
}
.ins-item-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  width: 22%;
  height: 100%;
}
.ins-txt-sub-container {
  /* background-color: antiquewhite; */
  line-height: 14px;
}
.ins-img2 {
  width: 80px;
  /* height: 66px; */
  object-fit: contain;
}
.ins-img {
  height: 80px;
  /* width: 55px; */
  /* width: 55px;
  height: 72px; */
  object-fit: contain;
}
.ins-bold-txt {
  font-size: 12px;
  font-family: InterLight, Arial, Helvetica, sans-serif;
  font-weight: 700;
  color: #fff;
}
.ins-bold-txt-title {
  font-size: 12px;
  font-family: InterLight, Arial, Helvetica, sans-serif;
  font-weight: 500;
}
.ins-light-txt {
  font-size: 12px;
  font-family: InterLight, Arial, Helvetica, sans-serif;
  font-weight: 400;
  color: #fff;
}
.ins-light-txt-mouse {
  font-size: 12px;
  font-family: InterLight, Arial, Helvetica, sans-serif;
  font-weight: 200;
  text-align: center;
  color: #fff;
}
.ins-partition {
  height: 20px;
}
.enter-button-img {
  /* height: 120%; */
  object-fit: contain;
}

.ins-enter-button {
  background-color: #000;
  color: #fff;
  width: 160px;
  font-size: 16px;
  padding: 6px;
  display: flex;
  font-family: InterLight, Arial, Helvetica, sans-serif;
  /* font-weight: 700; */
  justify-content: space-around;
  align-items: center;
  border: 1px solid #000;
  cursor: pointer;
  margin-top: 25px;
}

/* NEW CSS BUTTON */

.styled {
  cursor: pointer;
  width: 160px;
  padding: 6px;
  line-height: 1.4;
  font-size: 16px;
  text-align: center;
  vertical-align: middle;
  vertical-align: -webkit-baseline-middle;
  -webkit-font-smoothing: antialiased;
  font-weight: 400;
  background-color: #fff;
  color: #3f3636;
  cursor: pointer;
  margin-top: 20px;
  border-radius: 0px;
  border: 0px #fff solid;
}

.enter-text {
  background-color: #000;
  color: #fff;
  padding-top: 3px;
}
.ins-border {
  background-color: #d2d2d2;
  width: 1px;
  height: 100%;
}

.heading-form_0 {
  font-family: InterLight, Arial, Helvetica, sans-serif;
  font-size: 24px;
  font-weight: 300;
  line-height: 30.4px;
  color: #fff;
}

.heading-form {
  /* margin-top: 20px; */
  font-size: 17px;
  font-weight: 400;
  font-family: InterLight, Arial, Helvetica, sans-serif;
  color: #fff;
}

@media (max-width: 420px) {
  .heading-form {
    font-size: 10px;
    text-align: center;
  }

  .heading-form_0 {
    font-size: 14px;
    margin-bottom: 3px;
    line-height: 11px;
  }
  .ins-division {
    height: 200px;
    width: 300px;
  }

  .ins-sub-container {
    width: 100%;
    margin-top: 8px;
  }
  .ins-item-container {
    width: 32%;
    height: 100%;
  }
  .ins-img2 {
    width: 50px;
    height: 36px;
    object-fit: contain;
  }
  .ins-img {
    width: 50px;
    height: 36px;
    object-fit: contain;
  }
  .ins-bold-txt {
    font-size: 8px;
  }
  .ins-light-txt {
    font-size: 10px;
  }
  .ins-light-txt-mouse {
    font-size: 10px;
  }
  .ins-partition {
    height: 20px;
  }

  .styled {
    width: 120px;
    font-size: 12px;
    padding: 4px;
    margin-top: 15px;
  }
  .ins-enter-button {
    width: 120px;
    font-size: 12px;
    padding: 4px;

    margin-top: 15px;
  }
  .ins-border {
    /* background-color: #d9d9d9; */
    width: 1px;
    height: 100%;
  }
}

@media only screen and (min-width: 421px) and (max-width: 740px) {
  .heading-form {
    font-size: 13px;
  }
  .heading-form_0 {
    font-size: 16px;
    margin-bottom: 5px;
    line-height: 11px;
  }
  .form-close-icon {
    height: 30px;
    width: 30px;
  }

  .ins-division {
    height:60% ;
    width: 60%;
    margin-top: 5%;
  }

  .ins-sub-container {
    width: 100%;
    margin-top: 5px;
  }
  .ins-item-container {
    width: 22%;
    height: 100%;
  }
  .ins-img2 {
    width: 60px;
    height: 40px;
    object-fit: contain;
  }
  .ins-img {
    width: 60px;
    height: 40px;
    object-fit: contain;
  }
  .ins-bold-txt {
    font-size: 8px;
  }
  .ins-light-txt {
    font-size: 10px;
  }
  .ins-light-txt-mouse {
    font-size: 10px;
  }
  .ins-partition {
    height: 20px;
  }
  .styled {
    width: 120px;
    font-size: 12px;
    padding: 4px;
    margin-top: 15px;
  }
  .ins-enter-button {
    width: 120px;
    font-size: 12px;
    padding: 4px;

    margin-top: 15px;
  }
  .ins-border {
    /* background-color: #d9d9d9; */
    width: 1px;
    height: 100%;
  }
}

@media only screen and (min-width: 741px) and (max-width: 770px) {
  .heading-form {
    font-size: 14px;
  }
  .heading-form_0 {
    font-size: 17px;
    margin-bottom: 7px;
    line-height: 11px;
  }
  .form-close-icon {
    height: 35px;
    width: 35px;
  }
  .ins-division {
    height:60% ;
    width: 65%;
    margin-top: 5%;
  }

  .ins-sub-container {
    width: 100%;
    margin-top: 5px;
  }
  .ins-item-container {
    width: 22%;
    height: 100%;
  }
  .ins-img2 {
    width: 60px;
    height: 40px;
    object-fit: contain;
  }
  .ins-img {
    width: 60px;
    height: 40px;
    object-fit: contain;
  }
  .ins-bold-txt {
    font-size: 8px;
  }
  .ins-light-txt {
    font-size: 10px;
  }
  .ins-light-txt-mouse {
    font-size: 10px;
  }
  .ins-partition {
    height: 20px;
  }
  .styled {
    width: 100px;
    font-size: 12px;
    padding: 4px;
    margin-top: 15px;
  }
  .ins-enter-button {
    width: 100px;
    font-size: 12px;
    padding: 4px;
    margin-top: 15px;
  }
  .ins-border {
    /* background-color: #d9d9d9; */
    width: 1px;
    height: 100%;
  }
}

@media only screen and (min-width: 771px) and (max-width: 950px) {
  .heading-form {
    font-size: 13px;
  }
  .heading-form_0 {
    font-size: 17px;
    margin-bottom: 7px;
    line-height: 11px;
  }
  .form-close-icon {
    height: 30px;
    width: 30px;
  }
  .ins-division {
    height:60% ;
    width: 65%;
    margin-top: 5%;
  }

  .ins-sub-container {
    width: 100%;
    margin-top: 5px;
  }
  .ins-item-container {
    width: 22%;
    height: 100%;
  }
  .ins-img2 {
    width: 60px;
    height: 40px;
    object-fit: contain;
  }
  .ins-img {
    width: 60px;
    height: 40px;
    object-fit: contain;
  }
  .ins-bold-txt {
    font-size: 8px;
  }
  .ins-light-txt {
    font-size: 10px;
  }
  .ins-light-txt-mouse {
    font-size: 10px;
  }
  .ins-partition {
    height: 20px;
  }
  .styled {
    width: 120px;
    font-size: 14px;
    padding: 4px;
    margin-top: 17px;
  }
  .ins-enter-button {
    width: 120px;
    font-size: 12px;
    padding: 4px;
    margin-top: 15px;
  }
  .ins-border {
    /* background-color: #d9d9d9; */
    width: 1px;
    height: 100%;
  }
}
@media only screen and (min-width: 951px) and (max-width: 1150px) {
  .ins-division {
    height: 300px;
    width: 500px;
  }

  .ins-sub-container {
    width: 100%;
    margin-top: 20px;
  }
  .ins-division {
    height:65% ;
    width: 65%;
    margin-top: 5%;
  }
  .ins-item-container {
    width: 25%;
    height: 100%;
  }
  .ins-img2 {
    width: 80px;
    height: 60px;
    object-fit: contain;
  }
  .ins-img {
    width: 80px;
    height: 60px;
    object-fit: contain;
  }
  .ins-bold-txt {
    font-size: 12px;
  }
  .ins-light-txt {
    font-size: 12px;
  }
  .ins-light-txt-mouse {
    font-size: 12px;
  }
  .ins-partition {
    height: 25px;
  }

  .styled {
    width: 140px;
    font-size: 14px;
    padding: 4px;
    margin-top: 15px;
  }
  .ins-enter-button {
    width: 140px;
    font-size: 14px;
    padding: 4px;

    margin-top: 15px;
  }
  .ins-border {
    /* background-color: #d9d9d9; */
    width: 1px;
    height: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/enviroments/gabar/ui/Instruction/instruction.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;AACA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE;IACE;;;;;;;;sDAQkD;;GAEnD;;;;KAIE;IAED,0CAA0C;EAC5C;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;EACV,YAAY;AACd;AACA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB;iBACe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,qDAAqD;EACrD,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;EACf,qDAAqD;EACrD,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,qDAAqD;EACrD,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,eAAe;EACf,qDAAqD;EACrD,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,qDAAqD;EACrD,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;;AAEnB;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,uCAAuC;EACvC,mCAAmC;EACnC,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;;IAEZ,gBAAgB;EAClB;EACA;IACE,+BAA+B;IAC/B,UAAU;IACV,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,WAAW;IACX,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;;IAEZ,gBAAgB;EAClB;EACA;IACE,+BAA+B;IAC/B,UAAU;IACV,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,WAAW;IACX,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,+BAA+B;IAC/B,UAAU;IACV,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,WAAW;IACX,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,+BAA+B;IAC/B,UAAU;IACV,YAAY;EACd;AACF;AACA;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,UAAU;IACV,cAAc;EAChB;EACA;IACE,UAAU;IACV,YAAY;EACd;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;;IAEZ,gBAAgB;EAClB;EACA;IACE,+BAA+B;IAC/B,UAAU;IACV,YAAY;EACd;AACF","sourcesContent":[".parent-container-dummy {\n  position: absolute;\n  z-index: 4;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.show_screen {\n  opacity: 1;\n}\n.noshow_screen {\n  pointer-events: none;\n  opacity: 0;\n}\n\n.ins-division {\n  transition: all 2s;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n  width: 639px;\n  background-color: #fff;\n  position: relative;\n}\n\n@supports (-webkit-backdrop-filter: none) or (backdrop-filter: none) {\n  .ins-division {\n    /* background-color: rgba(255, 255, 255, 0.55);\n    background: radial-gradient(\n      100% 100% at 0% 0%,\n      rgba(255, 255, 255, 0.4) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n    -webkit-backdrop-filter: blur(16px) saturate(180%);\n    backdrop-filter: blur(16px) saturate(180%);\n    box-shadow: -5px -5px 250px 0px #ffffff05 inset; */\n    \n   background: radial-gradient(\n      100% 100% at 0% 0%,\n      rgba(169, 162, 162, 0.2) 70%,\n      rgba(151, 147, 147, 0.2) 100%\n    );\n    -webkit-backdrop-filter: blur(10px) saturate(100%);\n    backdrop-filter: blur(10px) saturate(100%);\n  }\n}\n\n.ins-sub-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  width: 100%;\n  margin-top: 20px;\n}\n.ins-item-container {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-direction: column;\n  width: 22%;\n  height: 100%;\n}\n.ins-txt-sub-container {\n  /* background-color: antiquewhite; */\n  line-height: 14px;\n}\n.ins-img2 {\n  width: 80px;\n  /* height: 66px; */\n  object-fit: contain;\n}\n.ins-img {\n  height: 80px;\n  /* width: 55px; */\n  /* width: 55px;\n  height: 72px; */\n  object-fit: contain;\n}\n.ins-bold-txt {\n  font-size: 12px;\n  font-family: InterLight, Arial, Helvetica, sans-serif;\n  font-weight: 700;\n  color: #fff;\n}\n.ins-bold-txt-title {\n  font-size: 12px;\n  font-family: InterLight, Arial, Helvetica, sans-serif;\n  font-weight: 500;\n}\n.ins-light-txt {\n  font-size: 12px;\n  font-family: InterLight, Arial, Helvetica, sans-serif;\n  font-weight: 400;\n  color: #fff;\n}\n.ins-light-txt-mouse {\n  font-size: 12px;\n  font-family: InterLight, Arial, Helvetica, sans-serif;\n  font-weight: 200;\n  text-align: center;\n  color: #fff;\n}\n.ins-partition {\n  height: 20px;\n}\n.enter-button-img {\n  /* height: 120%; */\n  object-fit: contain;\n}\n\n.ins-enter-button {\n  background-color: #000;\n  color: #fff;\n  width: 160px;\n  font-size: 16px;\n  padding: 6px;\n  display: flex;\n  font-family: InterLight, Arial, Helvetica, sans-serif;\n  /* font-weight: 700; */\n  justify-content: space-around;\n  align-items: center;\n  border: 1px solid #000;\n  cursor: pointer;\n  margin-top: 25px;\n}\n\n/* NEW CSS BUTTON */\n\n.styled {\n  cursor: pointer;\n  width: 160px;\n  padding: 6px;\n  line-height: 1.4;\n  font-size: 16px;\n  text-align: center;\n  vertical-align: middle;\n  vertical-align: -webkit-baseline-middle;\n  -webkit-font-smoothing: antialiased;\n  font-weight: 400;\n  background-color: #fff;\n  color: #3f3636;\n  cursor: pointer;\n  margin-top: 20px;\n  border-radius: 0px;\n  border: 0px #fff solid;\n}\n\n.enter-text {\n  background-color: #000;\n  color: #fff;\n  padding-top: 3px;\n}\n.ins-border {\n  background-color: #d2d2d2;\n  width: 1px;\n  height: 100%;\n}\n\n.heading-form_0 {\n  font-family: InterLight, Arial, Helvetica, sans-serif;\n  font-size: 24px;\n  font-weight: 300;\n  line-height: 30.4px;\n  color: #fff;\n}\n\n.heading-form {\n  /* margin-top: 20px; */\n  font-size: 17px;\n  font-weight: 400;\n  font-family: InterLight, Arial, Helvetica, sans-serif;\n  color: #fff;\n}\n\n@media (max-width: 420px) {\n  .heading-form {\n    font-size: 10px;\n    text-align: center;\n  }\n\n  .heading-form_0 {\n    font-size: 14px;\n    margin-bottom: 3px;\n    line-height: 11px;\n  }\n  .ins-division {\n    height: 200px;\n    width: 300px;\n  }\n\n  .ins-sub-container {\n    width: 100%;\n    margin-top: 8px;\n  }\n  .ins-item-container {\n    width: 32%;\n    height: 100%;\n  }\n  .ins-img2 {\n    width: 50px;\n    height: 36px;\n    object-fit: contain;\n  }\n  .ins-img {\n    width: 50px;\n    height: 36px;\n    object-fit: contain;\n  }\n  .ins-bold-txt {\n    font-size: 8px;\n  }\n  .ins-light-txt {\n    font-size: 10px;\n  }\n  .ins-light-txt-mouse {\n    font-size: 10px;\n  }\n  .ins-partition {\n    height: 20px;\n  }\n\n  .styled {\n    width: 120px;\n    font-size: 12px;\n    padding: 4px;\n    margin-top: 15px;\n  }\n  .ins-enter-button {\n    width: 120px;\n    font-size: 12px;\n    padding: 4px;\n\n    margin-top: 15px;\n  }\n  .ins-border {\n    /* background-color: #d9d9d9; */\n    width: 1px;\n    height: 100%;\n  }\n}\n\n@media only screen and (min-width: 421px) and (max-width: 740px) {\n  .heading-form {\n    font-size: 13px;\n  }\n  .heading-form_0 {\n    font-size: 16px;\n    margin-bottom: 5px;\n    line-height: 11px;\n  }\n  .form-close-icon {\n    height: 30px;\n    width: 30px;\n  }\n\n  .ins-division {\n    height:60% ;\n    width: 60%;\n    margin-top: 5%;\n  }\n\n  .ins-sub-container {\n    width: 100%;\n    margin-top: 5px;\n  }\n  .ins-item-container {\n    width: 22%;\n    height: 100%;\n  }\n  .ins-img2 {\n    width: 60px;\n    height: 40px;\n    object-fit: contain;\n  }\n  .ins-img {\n    width: 60px;\n    height: 40px;\n    object-fit: contain;\n  }\n  .ins-bold-txt {\n    font-size: 8px;\n  }\n  .ins-light-txt {\n    font-size: 10px;\n  }\n  .ins-light-txt-mouse {\n    font-size: 10px;\n  }\n  .ins-partition {\n    height: 20px;\n  }\n  .styled {\n    width: 120px;\n    font-size: 12px;\n    padding: 4px;\n    margin-top: 15px;\n  }\n  .ins-enter-button {\n    width: 120px;\n    font-size: 12px;\n    padding: 4px;\n\n    margin-top: 15px;\n  }\n  .ins-border {\n    /* background-color: #d9d9d9; */\n    width: 1px;\n    height: 100%;\n  }\n}\n\n@media only screen and (min-width: 741px) and (max-width: 770px) {\n  .heading-form {\n    font-size: 14px;\n  }\n  .heading-form_0 {\n    font-size: 17px;\n    margin-bottom: 7px;\n    line-height: 11px;\n  }\n  .form-close-icon {\n    height: 35px;\n    width: 35px;\n  }\n  .ins-division {\n    height:60% ;\n    width: 65%;\n    margin-top: 5%;\n  }\n\n  .ins-sub-container {\n    width: 100%;\n    margin-top: 5px;\n  }\n  .ins-item-container {\n    width: 22%;\n    height: 100%;\n  }\n  .ins-img2 {\n    width: 60px;\n    height: 40px;\n    object-fit: contain;\n  }\n  .ins-img {\n    width: 60px;\n    height: 40px;\n    object-fit: contain;\n  }\n  .ins-bold-txt {\n    font-size: 8px;\n  }\n  .ins-light-txt {\n    font-size: 10px;\n  }\n  .ins-light-txt-mouse {\n    font-size: 10px;\n  }\n  .ins-partition {\n    height: 20px;\n  }\n  .styled {\n    width: 100px;\n    font-size: 12px;\n    padding: 4px;\n    margin-top: 15px;\n  }\n  .ins-enter-button {\n    width: 100px;\n    font-size: 12px;\n    padding: 4px;\n    margin-top: 15px;\n  }\n  .ins-border {\n    /* background-color: #d9d9d9; */\n    width: 1px;\n    height: 100%;\n  }\n}\n\n@media only screen and (min-width: 771px) and (max-width: 950px) {\n  .heading-form {\n    font-size: 13px;\n  }\n  .heading-form_0 {\n    font-size: 17px;\n    margin-bottom: 7px;\n    line-height: 11px;\n  }\n  .form-close-icon {\n    height: 30px;\n    width: 30px;\n  }\n  .ins-division {\n    height:60% ;\n    width: 65%;\n    margin-top: 5%;\n  }\n\n  .ins-sub-container {\n    width: 100%;\n    margin-top: 5px;\n  }\n  .ins-item-container {\n    width: 22%;\n    height: 100%;\n  }\n  .ins-img2 {\n    width: 60px;\n    height: 40px;\n    object-fit: contain;\n  }\n  .ins-img {\n    width: 60px;\n    height: 40px;\n    object-fit: contain;\n  }\n  .ins-bold-txt {\n    font-size: 8px;\n  }\n  .ins-light-txt {\n    font-size: 10px;\n  }\n  .ins-light-txt-mouse {\n    font-size: 10px;\n  }\n  .ins-partition {\n    height: 20px;\n  }\n  .styled {\n    width: 120px;\n    font-size: 14px;\n    padding: 4px;\n    margin-top: 17px;\n  }\n  .ins-enter-button {\n    width: 120px;\n    font-size: 12px;\n    padding: 4px;\n    margin-top: 15px;\n  }\n  .ins-border {\n    /* background-color: #d9d9d9; */\n    width: 1px;\n    height: 100%;\n  }\n}\n@media only screen and (min-width: 951px) and (max-width: 1150px) {\n  .ins-division {\n    height: 300px;\n    width: 500px;\n  }\n\n  .ins-sub-container {\n    width: 100%;\n    margin-top: 20px;\n  }\n  .ins-division {\n    height:65% ;\n    width: 65%;\n    margin-top: 5%;\n  }\n  .ins-item-container {\n    width: 25%;\n    height: 100%;\n  }\n  .ins-img2 {\n    width: 80px;\n    height: 60px;\n    object-fit: contain;\n  }\n  .ins-img {\n    width: 80px;\n    height: 60px;\n    object-fit: contain;\n  }\n  .ins-bold-txt {\n    font-size: 12px;\n  }\n  .ins-light-txt {\n    font-size: 12px;\n  }\n  .ins-light-txt-mouse {\n    font-size: 12px;\n  }\n  .ins-partition {\n    height: 25px;\n  }\n\n  .styled {\n    width: 140px;\n    font-size: 14px;\n    padding: 4px;\n    margin-top: 15px;\n  }\n  .ins-enter-button {\n    width: 140px;\n    font-size: 14px;\n    padding: 4px;\n\n    margin-top: 15px;\n  }\n  .ins-border {\n    /* background-color: #d9d9d9; */\n    width: 1px;\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
